export default __webpack_public_path__ + "static/media/02.aecbbdc8.jpg";